import axios from "axios";
import { MessageBox, Message } from "element-ui";
import store from "@/store";
import { getToken } from "@/utils/auth";

// create an axios instance
const service = axios.create({
    baseURL: process.env.VUE_APP_BASE_API,
    // baseURL: "http://192.168.0.111:8080/mallmin",
    // baseURL: "http://192.168.0.75:8080/mallmin",
    // baseURL: "https://www.glorybeef.club/mallbbc",
    // http://192.168.3.40/mallJiaYue
    // baseURL: 'https://jytest.51domo.com/mallJiaYue',
    // withCredentials: true, // send cookies when cross-domain requests
    timeout: 600000 // request timeout
});

// request interceptor
service.interceptors.request.use(
    config => {
        // do something before request is sent
        if (store.getters.token) {
            // let each request carry token
            // ['X-Token'] is a custom headers key
            // please modify it according to the actual situation
            config.headers["X-Token"] = getToken();
        }
        return config;
    },
    error => {
        // do something with request error
        //console.log(error) // for debug
        return Promise.reject(error);
    }
);

// response interceptor
service.interceptors.response.use(
    /**
     * If you want to get http information such as headers or status
     * Please return  response => response
     */

    /**
     * Determine the request status by custom code
     * Here is just an example
     * You can also judge the status by HTTP Status Code
     */
    response => {
        const res = response.data;

        if (res.code == "401" || res.code == "403") {
            MessageBox.confirm(res.errorMsg, "确定登出", {
                confirmButtonText: "重新登录",
                cancelButtonText: "取消",
                type: "warning"
            }).then(() => {
                store.dispatch("user/logout").then(() => {
                    location.reload();
                });
            });
        }

        if (res.meta && !res.meta.success) {
            var msg = res.meta != undefined ? res.meta.message : res.message;
            if (res.meta.code === -1357) {
                MessageBox.confirm(msg, "提示", {
                    confirmButtonText: "确定",
                    type: "warning"
                });
            } else if (res.meta.code === 203 || res.meta.code === 204) {
                return Promise.reject(res.meta);
            } else {
                if (msg != "error") {
                    Message({
                        message: msg || "Error",
                        type: "error",
                        duration: 5 * 1000
                    });
                }
            }
            return Promise.reject(res.meta);
        } else {
            return res;
        }
    },
    error => {
        if (
            error.response &&
            error.response.status &&
            error.response.status == 500
        ) {
            Message({
                message: "服务器连接失败！" || "Error",
                type: "error",
                duration: 5 * 1000
            });
            return Promise.reject(error);
        }
        //console.log('err' + error) // for debug
        Message({
            message: error.message,
            type: "error",
            duration: 5 * 1000
        });
        return Promise.reject(error);
    }
);

export default service;
